import {bindable, customElement, inject} from "aurelia-framework";
import {Router,NavigationResult} from "aurelia-router";
import {EventAggregator,Subscription} from 'aurelia-event-aggregator';

@customElement('url-navigation')
export class UrlNavigation {
    @bindable() routeName;
    private subscriber: Subscription;
    isActive : boolean;
    constructor(private router: Router, private eventAggregator : EventAggregator) {
    }

    navigateClicked(route){
        this.router.navigateToRoute(this.routeName);
    }
    attached() {
        this.subscriber = this.eventAggregator.subscribe('router:navigation:complete', instruction => {
            this.isActive = (instruction.instruction.config.name == this.routeName)
          
        });
    }
}


